import { Injectable } from '@angular/core';
import { Observable, of, shareReplay } from 'rxjs';
import { Api } from 'services/http/api-endpoints';
import { HttpService } from 'services/http/http.service';
import { Endpoint } from 'services/http/interface/endpoint';
import { Route } from 'services/http/routes';
import { Update } from './request/update';


export interface EdgeDevice {
  edgeId: string;
  label: string;
}

@Injectable({
  providedIn: 'root'
})
export class EdgeDeviceService {

  private edgeDevices: Array<EdgeDevice> = []
  private cachedEdgeDevices: Observable<Array<EdgeDevice>> = of()

  public get devices(): Array<EdgeDevice> {
    return this.edgeDevices
  }

  public list(): Observable<Array<EdgeDevice>> {
    return this.cachedEdgeDevices
  }

  public update(id: string, label: string): Observable<any> {
    const body: Update = new Update(label)
    const endpoint: Endpoint = Api.getEndpoint(Api.edgeDevice, Route.EdgeDevice.Update);
    return this.httpService.request(Api.edgeDevice, Route.EdgeDevice.Update, Api.createParameters(endpoint.route, [id]), body)
  }

  constructor(
    private httpService: HttpService
  ) {
    this.refreshEdgeDevices()
  }

  public refreshEdgeDevices(): void {
    this.cachedEdgeDevices = this.getEdgeDevices().pipe(shareReplay(1))
  }

  private getEdgeDevices(): Observable<Array<EdgeDevice>> {
    return this.httpService.request(Api.edgeDevice, Route.EdgeDevice.List)
  }

}
